export const NOTIFICATION_UNITS = {
    days: "Días",
    weeks: "Semanas",
    months: "Meses",
    years: "Años",
  };